import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/decking-calculator',
  component: () => import('../../routes/DeckingCalculator.svelte'),
  card: {
    id: 'decking-calculator',
    title: 'Decking Calculator',
    description:
      'Calculate deck boards, joists, posts, concrete footings, screws, and total cost for any rectangular deck. Supports 5/4x6, 2x6, and 2x4 boards with 12"/16"/24" on-center joist spacing.',
    icon: 'carpenter',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/decking-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Decking Calculator – Boards, Joists, Posts, and Cost for Any Deck',
    description:
      'Free decking calculator. Estimate deck boards, joists, support posts, concrete footings, screws, and total project cost. Supports 5/4x6, 2x6, and 2x4 boards with 12", 16", or 24" on-center joist spacing.',
  },
};

export default meta;
